import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { ColorSet } from 'src/redux/reducers/theme';

interface FooterProps {
  footerComponent?: React.ReactNode;
  colors: ColorSet;
}

export const Footer: React.FC<FooterProps> = ({ footerComponent, colors }) => {
  return (
    <View
      fixed
      style={{
        position: 'absolute',
        minHeight: 36,
        margin: '0 36px',
        marginTop: 14,
        paddingVertical: 10,
        bottom: 0,
        borderTop: `1px solid ${colors.stroke}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        left: 0,
        right: 0,
        flexDirection: 'row',
      }}
    >
      {footerComponent}
      <View style={{ width: 30 }} />
      <Text
        style={{
          fontSize: 10,
          textAlign: 'right',
          color: colors.davysGrey,
          fontWeight: 500,
        }}
        render={({ pageNumber }) => `${pageNumber}`}
      />
    </View>
  );
};
